<div class="card panel-monsido-card">
    <div class="card-header">
        <h2 class="font-weight-300 mb-1" translate>
            Most common opportunities found
        </h2>
        <span class="text-grey"
              translate
              [translate-args]="{issues: seoIssues.length}"
              [translate-n]="seoIssues.length"
              translate-plural="You have [[issues]] to dos">
            You have 1 to do
        </span>
    </div>
    <div class="card-body">
        <mon-spinner [progress]="progress" [loading]="loading">
            <div class="row" *ngFor="let issue of seoIssues">
                <div class="col-48 col-lg-20 inner-b-medium inner-r-none">
                    <span class="inline-block text-nowrap text-ellipsis max-width">
                        <span class="fas fa-circle inner-r-mini {{ seoClassifications[issue.classification] }}"></span>
                        {{ issue.name | translateSeoIssue }}
                    </span>
                </div>
                <div class="col-48 col-lg-28 inner-b-medium">
                    <seo-issues-btn-group [count]="issue.pages_count" [highestNo]="seoIssuesHighestPageCount">
                        <ng-container>
                            <li>
                                <button
                                        type="button"
                                        [attr.aria-label]="'Ignore this SEO issue' | translate"
                                        class="btn btn-link btn-secondary cursor-pointer text-left w-100"
                                        [monModalConfirm]="'Are you sure, you want to ignore issue <strong>' + (issue.name | translateSeoIssue) + '</strong>?'"
                                        (monModalConfirmAction)="ignoreIssue(issue)">
                                    {{ 'Ignore this check' | translate }}
                                </button>
                            </li>
                            <li>
                                <button
                                        type="button"
                                        [attr.aria-label]="'Show pages with this SEO issue' | translate"
                                        class="btn btn-link btn-secondary cursor-pointer text-left w-100"
                                        (click)="getPagesFromSeoIssue(issue)">
                                    {{ 'See pages' | translate }}
                                </button>
                            </li>
                        </ng-container>
                    </seo-issues-btn-group>
                </div>
            </div>
        </mon-spinner>
    </div>
</div>
